<template>
    <div>

        <!-- PDF MESAGGE POPUP -->
        <v-layout row justify-center>
            <v-dialog v-model="isPopupOpen"
                      persistent
                      scrollable
                      max-width="600"
                      content-class="dialog-chatbot-translate-pdf"
                      transition="dialog-bottom-transition">

                <v-card class="component-bg-color ">

                    <v-card-title style="justify-content: center; max-height: 55px;">
                        <span  @click="closePopup" class="float-left cursor-pointer" style="position: absolute;left: 15px; top: 15px;">
                            <close-icon :svg-fill-class="'svg-secondary-color'"/>

                        </span>
                        <span class="font-weight-bold">{{text('pdf.message.recipient.title')}}</span>
                    </v-card-title>

                    <v-card-text>

                        <v-card class="translate-pdf-container assessment-share-page-btn-action popup-scoring-assessment component-bg-color">

                            <v-flex xs12 sm12 class="no-padding-left no-padding-bottom">

                                <br />
                                <span>{{text('pdf.message.recipient.subtitle')}}</span>
                                <v-text-field
                                    v-model="pdfMessageRecipient"
                                    :placeholder="text('pdf.message.recipient.placeholder.short')"
                                    @change="validateRecipient"
                                    solo
                                ></v-text-field>

                                <p v-if="!isPdfMessageRecipientValid" class="phone-error">{{pdfMessageRecipientErrorText}}</p>
                                <p v-if="apiStatesPhoneRecipientInvalid" class="phone-error">{{text('pdf.message.recipient.not.available')}}</p>

                                <br />

                                <p>{{text('pdf.message.agreeToService')}}</p>
                                <v-checkbox
                                    v-model="userAgreement"
                                    :rules="userAgreementCheckboxRule"
                                    :label="text('pdf.message.agreeToService.label')"
                                    hide-details
                                    color="primary"
                                    class="pdf-message-user-agreement-checkbox">
                                </v-checkbox>
                            </v-flex>

                            <div v-if="getPdfTemplateList.length > 0" class="card__title headline">
                                <span class="font-weight-bold">{{text('api.share.page.translatePdf.selectTemplate')}}</span>
                            </div>

                            <div v-if="getPdfTemplateList.length > 0">
                                <v-flex xs12 sm12 class="no-padding-left">
                                    <div class="pdf-template-list">

                                        <pdf-template-selector-radio-group
                                            :selected-template="selectedPdfTemplate"
                                            @onChangeSelectedTemplate="selectedPdfTemplate = $event.selectedPdfTemplate"
                                        ></pdf-template-selector-radio-group>

                                    </div>
                                </v-flex>
                            </div>


                            <div v-if="getThreemaTranslateLanguageList.length > 0">
                                <span class="font-weight-bold card__title headline">{{text('api.share.page.translatePdf.selectLanguage')}}</span>
                                <v-flex xs12 sm12 class="no-padding-left">

                                    <div class="pdf-template-list">
                                        <pdf-translate-language-selector-radio-group
                                            :selected-language="selectedPdfLanguage"
                                            :language-list="getThreemaTranslateLanguageList"
                                            @onChangeSelectedPdfLanguage="selectedPdfLanguage = $event.selectedPdfLanguage"
                                        ></pdf-translate-language-selector-radio-group>
                                    </div>

                                </v-flex>
                            </div>
                        </v-card>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn @click="handleClickSendBtn()"
                               :loading="loading"
                               round
                               :disabled="!isFormValid"
                               color="primary"
                               class="text-transform-none color-on-primary-text">
                            {{text('api.button.send')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import PdfTemplateSelectorRadioGroup
    from "../../../common/components/shared/assessment-share/PdfTemplateSelectorRadioGroup";
import CloseIcon from "../../../common/components/svg/shared/closeIcon";
import PdfTranslateLanguageSelectorRadioGroup
    from "../../../common/components/shared/assessment-share/PdfTranslateLanguageSelectorRadioGroup";
import Vue from "vue";
import axios from "axios";

export default {
    name: 'PdfMessageFormPopup',
    components: {
        CloseIcon,
        PdfTemplateSelectorRadioGroup,
        PdfTranslateLanguageSelectorRadioGroup
    },

    props: {
        isPopupOpen: {
            type: Boolean,
            default: false
        },
        assessmentToken: String,
        assessmentVersion: String,
    },
    data() {
        return {
            loading: false,
            pdfMessageRecipient: '', // Can be filled with a phone number, an email address or a Threema ID.
            pdfMessageRecipientErrorText: "",
            userAgreement: "",
            userAgreementCheckboxRule: [
                (value) => (value == true)
            ],
            selectedPdfTemplate: '',
            selectedPdfLanguage: 'or',
            isSent: false,
            checkBoxPlugin: Vue.CheckBox.checkBoxSvg,
            apiStatesPhoneRecipientInvalid: false,
        };
    },

    computed: {
        ...mapGetters({
            getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
            getAppPropertyValueArray: 'TranslationStore/getAppPropertyValueArray'
        }),

        getPdfTemplateList() {
            return this.getAppPropertyValueArray('PDF_TEMPLATE');
        },
        getThreemaTranslateLanguageList() {
            let threemaLanguages = this.getAppPropertyValueArray('THREEMA_TRANSLATE_LANGUAGES');

            // if there aren't any THREEMA_TRANSLATE_LANGUAGES, we do not need to add the button for Original Language,
            // in all other cases we need it.
            if(threemaLanguages.length > 0){
                threemaLanguages.unshift("or");
            }

            return threemaLanguages;
        },
        findTemplateNameForDisplay() {
            return (template) => {
                return (this.text('pdf.template.name.' + template).length > 0)
                    ? this.text('pdf.template.name.' + template)
                    : template;
            };
        },
        findLanguageNameForDisplay() {
            return (langKey) => {
                return (this.text('api.language.name.' + langKey).length > 0)
                    ? this.text('api.language.name.' + langKey.toLowerCase() )
                    : langKey;
            };
        },
        isPdfMessageRecipientValid() {
            return (this.pdfMessageRecipientErrorText.length > 0) ? false : true;
        },
        isFormValid() {
            return (
                this.selectedPdfTemplate !== ""
                && this.pdfMessageRecipient !== ""
                && this.isPdfMessageRecipientValid === true
                && this.userAgreement == true
            ) ? true : false;
        }
    },

    beforeMount() {
        if (this.getPdfTemplateList.length === 1) {
            // If there is only one PDF template, consider it already selected (so it will be automatically selected
            // and no radio buttons for template selection will be displayed).
            this.selectedPdfTemplate = this.getPdfTemplateList[0];
        }
    },

    watch: {
        isPopupOpen(newVal, oldVal) {
            if (oldVal === false && newVal === true) {
                // OPEN POPUP.

                // ----- Set popup height (fix for iPad/Safari) and answer list scrollable area height -----
                this.setPopupHeight();
            }
        },
        userAgreement(newValue, oldValue) {
            if (newValue === true) {
                let that = this;
                setTimeout(function () {
                    let userAgreementCheckbox = document.getElementsByClassName('pdf-message-user-agreement-checkbox');
                    for (let i = 0; i < userAgreementCheckbox.length; i++) {
                        let iconCheckBox = userAgreementCheckbox[i].getElementsByClassName('icon--checkbox');

                        for (let j = 0; j < iconCheckBox.length; j++) {
                            iconCheckBox[j].innerHTML = that.checkBoxPlugin();
                        }
                    }
                }, 10);
            }
        }
    },


    mounted() {
        window.addEventListener('resize', this.UtilitiesPlugin.debounce(this.setPopupHeight, 200));

    },

    beforeDestroy() {
        window.removeEventListener('resize', this.UtilitiesPlugin.debounce(this.setPopupHeight, 200));
    },

    methods: {

        validateRecipient(value) {
            let errorMsg = "";

            if (value.length < 1) {
                errorMsg = this.text("api.error.field.required");
            }

            const phoneRegex = /^((\+|00)\d{2}|0)(( )?\d){9,12}$/;
            const mailRegex = /^(([a-zA-Z0-9_\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df\-.]+)@((\[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df\-]+\.)+))([a-zA-Z\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]{2,15}|[0-9]{1,3})(]?)(\s*\040\s*|\s*$))*$/;
            const threemaIDRegex= /^[A-Z0-9]{8}$/;

            if(!phoneRegex.test(value) && !mailRegex.test(value) && !threemaIDRegex.test(value)){
                errorMsg = this.text("pdf.message.recipient.invalid")
                    + " (" + this.text('pdf.message.recipient.placeholder') + ")";
            }

            this.pdfMessageRecipientErrorText = errorMsg;
        },

        closePopup() {
            this.$emit('onClosePopup');
        },

        handleClickSendBtn() {
            this.loading = true;

            let requestParams = this.buildParamsForPdfCreation({
                recipient: this.pdfMessageRecipient,
                userAgrees: this.userAgrees,
                template: this.selectedPdfTemplate,
                // translationLanguage "or" = Original Language of the assessment
                translationLanguage: (this.selectedPdfLanguage === "or") ?
                    "" : this.selectedPdfLanguage,
            });

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/deliverPDFMessage', requestParams);

            axiosRequest
                .then((response) => {
                    if (typeof response.data.returnCode !== "undefined"
                        && response.data.returnCode === 240) {
                        this.apiStatesPhoneRecipientInvalid = true;
                        this.valid = false;
                        this.loading = false;
                    } else {
                        this.apiStatesPhoneRecipientInvalid = false;
                        this.loading = false;
                        this.closePopup();
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    console.error(error);
                });

        },

        /**
         * @TODO:
         * Consider moving this method to a separate file (ex. a Vue plugin, something like AssessmentSharePlugin.js,
         * for example), because maybe we can include it in PFI/PRO Share Assessment page and use the same method
         * there as well, in order to reduce code duplication.
         */
        buildParamsForPdfCreation(additionalParams){

            // ----- Default params/values. -----
            let requestParams = {
                assessmentToken: this.assessmentToken,
                assessmentVersion: this.assessmentVersion,
                template: additionalParams.template, // If no template name is passed, the API will use the default template.
                translationLanguage: additionalParams.translationLanguage,
                decisionItem1Label: null,
                decisionItem1Color: null,
                decisionItem2Label: null,
                decisionItem2Icon: null,
                decisionText: "",
                disclaimer1: "",
                disclaimer2: ""
            };

            if (typeof additionalParams.recipient !== "undefined") {
                requestParams.recipient = additionalParams.recipient;
            }
            // `userAgrees` is used together with the `recipient` param. It's the value of the checkbox used
            // for the user to confirm that he/she agrees to use an external message provider to transfer
            // the E2E encrypted message.
            if (typeof additionalParams.userAgrees !== "undefined") {
                requestParams.userAgrees = additionalParams.userAgrees;
            }

            return requestParams;
        },


        /**
         * Compute and set popup height (fix for iPad/Safari?).
         * @return {Promise}
         */
        setPopupHeight() {

            let promise = new Promise((resolve, reject) => {

                let popupElem = document.querySelector(".dialog-chatbot-translate-pdf");
                let newPopupHeight;

                if (window.innerWidth >= 600) {
                    // Medium and big screens.
                    let pageHeaderHeight = document.querySelector(".chatbot-page-header nav.header-pathfinder");
                    if(pageHeaderHeight) {
                        let pageHeaderOffsetHeight = pageHeaderHeight.offsetHeight;
                        newPopupHeight = window.innerHeight - pageHeaderOffsetHeight;
                    }
                }
                else {
                    // Small screens.
                    newPopupHeight = window.innerHeight;
                }

                if (popupElem) {
                    popupElem.style.height = newPopupHeight + "px";
                }
                resolve(newPopupHeight);
            });

            return promise;
        },

    }

}
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
     .phone-error {
        padding-top: 4px;
        color: #ff0000 !important;
    }

    .no-padding.card {
        border-radius: 20px !important;
    }

    h2.title {
        font-weight: $font-weight-bold;
       // color: $color-brand-primary;
        font-size: $font-size-big;
    }

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/PdfMessageFormPopup.vue